module.exports = __webpack_public_path__ + "static/media/fathom.846711d3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/fathom.jpg
 ** module id = 429
 ** module chunks = 0
 **/